import { ProductCustomizationComponent } from './ordering/product-customization/product-customization.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CartComponent } from './ordering/cart/cart.component';
import { PaymentActivityComponent } from 'src/app/modules/order-track/payment-activity/payment-activity.component';
const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/ordering' },
  { path: 'ordering', loadChildren: () => import('./ordering/ordering.module').then(m => m.OrderingModule) },
  { path: 'rewards', loadChildren: () => import('./reward-loyality/rewards/rewards.module').then(m => m.RewardsModule) },
  { path: 'pay', loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule) },
  { path: 'payment-activity', component: PaymentActivityComponent },
  { path: 'cart', component: CartComponent },
  { path: 'profile', loadChildren: () => import('./modules/user-profile/user-profile.module').then(m => m.UserProfileModule) },
  { path: 'order-track', loadChildren: () => import('./modules/order-track/order-track.module').then(m => m.OrderTrackModule) },
  { path: 'search', loadChildren: () => import('./modules/global-search/global-search.module').then((m => m.GlobalSearchModule)) },
  { path: ':category/:product', component: ProductCustomizationComponent },
  { path: '**', loadChildren: () => import('./ordering/ordering.module').then(m => m.OrderingModule) }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabled', relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
